import { cn } from "@newxsystems/shared";
import { WohaCardLink } from "../WohaCardLink/WohaCardLink";
import { WohaMedia } from "../WohaMedia/WohaMedia";
import { WohaRichText } from "../WohaRichText/WohaRichText";
import type { IImageContentGridTopProps } from "./ImageContentGridTop.props";
const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;
export const ImageContentGridTop = ({
  columnCount,
  imageAspectRatio,
  items,
}: IImageContentGridTopProps) => (
  <div
    className={cn("grid grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2", columns[columnCount || 3])}
  >
    {items.map((item, index) => (
      <WohaCardLink
        className="overflow-visible rounded-none border-0 bg-transparent hover:translate-y-0"
        key={index}
        link={item.cardLink}
      >
        <WohaMedia
          aspectRatio={imageAspectRatio || "16:9"}
          className="overflow-hidden rounded-2xl"
          media={item.image.image}
          sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
        />
        <div className="px-1 pt-6">
          <h3 className="font-satoshi text-2xl font-medium leading-tight text-charcoal transition-colors group-hover:text-electric-blue">
            {item.heading}
          </h3>
          {item.description ? (
            <WohaRichText
              className="mt-3 text-base leading-7 text-steel"
              content={item.description}
            />
          ) : null}
        </div>
      </WohaCardLink>
    ))}
  </div>
);
ImageContentGridTop.displayName = "Content::ImageContentGridTop";
